import * as React from "react"
import { curry } from "ramda"

const formElements = () => [
  HTMLInputElement,
  HTMLSelectElement,
  HTMLTextAreaElement
]
const isFormElement = (target: EventTarget) =>
  formElements().some(t => target instanceof t)

const interactiveElements = () => [
  HTMLAudioElement,
  HTMLAnchorElement,
  HTMLButtonElement,
  // HTMLDetailsElement, // Not available in IE 11
  HTMLVideoElement,
  ...formElements()
]
const isInteractiveElement = (target: Element) =>
  interactiveElements().some(t => target instanceof t)

const hasEventKey = curry(
  (keys: string[], event: React.KeyboardEvent) => keys.indexOf(event.key) !== -1
)

const isHTMLElement = (element: Element): element is HTMLElement =>
  element instanceof HTMLElement

const isDisabledElement = (element: HTMLElement) =>
  Boolean((element as HTMLInputElement).disabled)

const hasTabindex = (element: HTMLElement) => element.hasAttribute("tabindex")

const isFocusableElement = (element: Element) => {
  if (!isHTMLElement(element) || isDisabledElement(element)) return false
  return isInteractiveElement(element) || hasTabindex(element)
}

export { isFocusableElement, isFormElement, isInteractiveElement, hasEventKey }
